module.exports = __webpack_public_path__ + "media/topSection/2-7532052d.png";